/**
 * Theme Configuration
 * ===================
 * Per-profile: change colors to match your brand.
 *
 * Theme token reference:
 *   --bg-page          Page background
 *   --primary          Primary accent color
 *   --primary-dark     Darker variant for hover/active
 *   --header-start     Header gradient start
 *   --header-end       Header gradient end
 *   --footer-start     Footer gradient start
 *   --footer-end       Footer gradient end
 *   --text-primary     Main text color
 *   --text-secondary   Muted/secondary text
 *   --border           Border color
 *   --gold             Featured/accent gold
 *   --shadow-*         Box shadow tokens
 *   --radius-*         Border radius tokens
 *
 * Each token maps to a CSS variable in App.css.
 * Define only the tokens you need to override.
 * Unmentioned tokens keep the default values.
 */

const THEME = {
  // Backgrounds
  bgPage: '#FDF8F5',
  bgWhite: '#ffffff',
  bgLight: '#f0f0f0',
  bgHover: '#f0ebe8',
  bgAutocompleteHover: '#f8f9fa',
  bgCardOverlay: 'rgba(209, 122, 114, 0.9)',

  // Text
  textPrimary: '#4A3B39',
  textSecondary: '#7C6B68',
  textMuted: '#A99F9C',
  textBody: '#4A3B39',
  textWhite: '#ffffff',

  // Primary accent (rose)
  primary: '#D17A72',
  primaryDark: '#C06860',
  primaryRgb: '209, 122, 114',

  // Header (beige)
  headerStart: '#E9D5C8',
  headerEnd: '#DFC4B5',
  headerRgb: '233, 213, 200',

  // Featured / gold
  gold: '#FFD700',
  goldBgStart: '#FFFBF0',
  goldBgEnd: '#FFF8E7',
  goldBgHover: '#FFF0D0',

  // Footer
  footerStart: '#7C4B44',
  footerEnd: '#6B3D37',

  // Borders
  border: '#e0d8d4',
  borderLight: '#f0ebe8',

  // Shadows
  shadowSm: '0 4px 12px rgba(0, 0, 0, 0.06)',
  shadowMd: '0 8px 24px rgba(0, 0, 0, 0.08)',
  shadowLg: '0 12px 32px rgba(0, 0, 0, 0.12)',
  shadowHeader: '0 8px 32px rgba(209, 122, 114, 0.15)',
  shadowPrimary: '0 4px 12px rgba(209, 122, 114, 0.3)',
  shadowSocial: '0 8px 16px rgba(0, 0, 0, 0.3)',
  shadowBtn: '0 8px 16px rgba(0, 0, 0, 0.2)',
  shadowDetail: '0 4px 12px rgba(0, 0, 0, 0.1)',

  // Border radius
  radiusSm: '8px',
  radiusMd: '12px',
  radiusLg: '16px',
  radiusXl: '20px',
  radiusFull: '24px',

  // Layout
  maxWidth: '1200px',
};

export { THEME };
export default THEME;

/** Map of CSS variable names to their theme values, for dynamic injection */
export const THEME_CSS_VARS = Object.fromEntries(
  Object.entries(THEME).map(([key, value]) => [
    `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`,
    value,
  ])
);
